import { create } from 'zustand';

const userStore = create((set, get) => ({
  currentURL: null, // Exemple: 'home', 'about', 'details', etc.

  setCurrentURL: (url) => set({ currentURL: url }),

  registeredHandler: null,
  registerHandler: (fn) => set({ registeredHandler: fn }),

  // Appel depuis n'importe où
  triggerHandler: () => {
    const { currentURL, registeredHandler } = get();
    
    if (currentURL && typeof registeredHandler === 'function') {
      registeredHandler(currentURL);
    }
  },

}));

export default userStore;
